export enum LocationAttr {
    DistributionCenter = 'distributionCenter',
    LocationStatus = 'locationStatus',
    LocationTypeCode = 'locationTypeCode',
    MarketName = 'marketName',
};